import { FC } from 'react'
import { ConclusionObjectivePayment } from '../../../objectivePayment/ConclusionObjectivePayment'
import {
  ObjectiveStatus,
  FullOneOffPaymentFragment,
  FullObjectivePaymentFragment,
  ObjectiveDto,
  TargetCorrectionPaymentDto,
  Country,
} from '../../../../types'
import PerText from '../../../../components/custom_components/Text'
import { useTranslation } from 'react-i18next'
import { ConclusionOneOffPayment } from '../../one-off-payment/ConclusionOneOffPayment'
import { Divider } from 'antd'
import { filterObjectivesByTypeStatusAndRefYear } from '../../okr/util'
import { ConclusionTargetCorrectionPayment } from '../../target-correction-payment/ConclusionTargetCorrectionPayment'
import useCountrySettings from '../../../../graphql/countrySettings/hooks/useCountrySettings'
import { LoadingAndErrors } from '../../../../components/custom_components/LoadingAndErrors'

interface ConclusionPaymentProps {
  country: Country
  objectives: ObjectiveDto[]
  oneOffPayment?: FullOneOffPaymentFragment
  objectivePayment?: FullObjectivePaymentFragment
  targetCorrectionPayment?: TargetCorrectionPaymentDto
}

export const ConclusionPayment: FC<ConclusionPaymentProps> = ({
  country,
  objectives,
  oneOffPayment,
  objectivePayment,
  targetCorrectionPayment,
}) => {
  const [t] = useTranslation()

  const objectivesToBePaid = filterObjectivesByTypeStatusAndRefYear(objectives, true, [
    ObjectiveStatus.Approved,
    ObjectiveStatus.PastApproved,
  ]).filter((x) => x.achievedAmount !== undefined && x.achievedAmount !== null && x.achievedAmount >= 0)

  const targetCorrectionPaymentExists = targetCorrectionPayment && !!targetCorrectionPayment
  const oneOffPaymentExists = oneOffPayment && !!oneOffPayment.resultAmount
  const deductionExists = objectivePayment && !!objectivePayment.deduction
  const objectivePaymentsExists = objectivesToBePaid.length > 0
  const showPayment = oneOffPaymentExists || objectivePaymentsExists || deductionExists || targetCorrectionPaymentExists

  const { data, loading, error } = useCountrySettings(country)
  if (!data || !data.getCountrySettings || loading || error) {
    return <LoadingAndErrors hasNoData={!data || !data.getCountrySettings} isLoading={loading} error={error} />
  }

  const countrySettings = data.getCountrySettings

  return (
    <>
      {showPayment && (
        <div data-e2e-payment-conclusion>
          <PerText appearance="heading" color="primary" mb="s">
            {t('appraisalMeeting.conclusion.paymentTitle')}
          </PerText>

          {countrySettings.paymentsAndChangesDisclaimerVisible && (
            <PerText color="secondary" mb="s">
              {t(`appraisalMeeting.conclusion.notOnFirstOfMonthDisclaimer`)}
            </PerText>
          )}

          {(deductionExists || objectivePaymentsExists) && (
            <ConclusionObjectivePayment objectivesToBePaid={objectivesToBePaid} objectivePayment={objectivePayment} />
          )}

          {oneOffPaymentExists && oneOffPayment && (
            <ConclusionOneOffPayment oneOffPayment={oneOffPayment} showSpacer={objectivePaymentsExists} />
          )}

          {targetCorrectionPaymentExists && targetCorrectionPayment && (
            <ConclusionTargetCorrectionPayment
              targetCorrectionPayment={targetCorrectionPayment}
              showSpacer={objectivePaymentsExists || !!oneOffPaymentExists}
            />
          )}

          <Divider />
        </div>
      )}
    </>
  )
}
